export interface JobView {
  id: number;
  jobName: string;
  siteName: string;
  purchaseOrderNumber: string;
  status: JobStatus;
  jobType: JobType;
  jobSubType: JobSubType;
  jobPriority: JobPriority;
  attendanceDate: Date;
  engineersAssigned: number;
  attachments: number;
  paperworkRequired: boolean;
  submittedAnswer: boolean;
}

export enum JobStatus {
  NotApplicable = 'NotApplicable',
  Open = 'Open',
  Complete = 'Complete',
  Cancelled = 'Cancelled',
  AwaitingClosure = 'AwaitingClosure',
  InProgress = 'InProgress'
}

export enum JobType {
  NotApplicable = 'NotApplicable',
  Service = 'Service',
  Install = 'Install'
}

export enum JobSubType {
  NotApplicable = 'NotApplicable',
  Player = 'Player',
  SoundSystem = 'SoundSystem',
  Install = 'Install',
  Survey = 'Survey'
}

export enum JobPriority {
  Normal = 'Normal',
  High = 'High'
}
